import * as api from './index';

export function getSites(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/sites?${queryString}`);
}

export function getSite(id) {
    return api.get(`/sites/${id}`);
}

export function createSite(site) {
    return api.post('/sites', site);
}

export function updateSite(site) {
    return api.patch(`/sites/${site.id}`, site);
}

export function softDeleteSite(site) {
    return api.del(`/sites/${site.id}/soft`);
}
